import type { WebModule } from '@nw/web-platform';
import { libraryWeb } from '@nw/library/web';
import { mindWeb } from '@nw/mind-networks/web';
import { specimensWeb } from '@nw/fixture-specimens/web';

/** Browser-side registrations. Fixture modules are included only in development/test builds. */
export const webModules: WebModule[] = [
  libraryWeb,
  mindWeb,
  ...(import.meta.env.VITE_ENABLE_FIXTURE_MODULES === 'true' && import.meta.env.MODE !== 'production' ? [specimensWeb] : []),
];
